import React, { Component } from 'react';
import { Form, Input, Row, Col } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { isValidArray } from 'src/Library/Helper';
import useField, { useFieldProps } from 'src/hooks/form/useField';
import useInput from 'src/hooks/form/useInput';
import useMultiField from 'src/hooks/form/useMultiField';
import { FieldNodeProps } from './form.types';

export type FieldNodeSingleRef = {
  field: ReturnType<typeof useField>;
  // children: React.ReactElement;
};

const FieldNodeSingle = (useHook, value?: any) => React.forwardRef<FieldNodeSingleRef, FieldNodeProps>(
  ({ children, requestRerender, formKey, ...props }, ref) => {
    const hookProps = {
      ...props,
      key: formKey,
    };
    if (value) {
      hookProps.value = value;
    }
    const field = useHook(hookProps);
    if (ref) {
      (ref as any).current = { field };
    }

    const child = React.Children.only(children);
    return <>{React.isValidElement(child) ? field.decorator(child) : children}</>;
  }
);

export default FieldNodeSingle;
